const projects = [
  {
    id: 1,
    title: "Phonebook",
    description: "A little SPA for saving and storage contacts.",
    src: "images/project-contacts.jpeg",
    gitHubLink: "https://github.com/still-me/goit-react-hw-09-phonebook",
    livePage: "https://sm-contacts-book.netlify.app/contacts",
    technologies: ["React", "Redux", "React-router", "Axios", "react-hooks"],
  },
  {
    id: 2,
    title: "Events",
    description: "A website for searching events. [Command project]",
    src: "images/project-events.jpeg",
    gitHubLink: "https://github.com/still-me/js-project-group-07",
    livePage: "https://goodluckmister.github.io/js-project-group-07/",
    technologies: ["Java Script", "SASS", "Handlebars", "REST API", "Webpack"],
  },
  {
    id: 3,
    title: "Tic-tac-toe Game",
    description:
      "The game that everyone has played at least once in their life.",
    src: "images/project-ttt.jpeg",
    gitHubLink: "https://github.com/still-me/tic-tac-toe-game",
    livePage: "https://tic-tac-toe-sm.netlify.app/",
    technologies: ["React", "Redux-toolkit"],
  },
  {
    id: 4,
    title: "WebStudio",
    description: "A website with semantic and adaptive layout.",
    src: "images/project-studio.jpeg",
    gitHubLink: "https://github.com/still-me/goit-markup-hw-08",
    livePage: "https://still-me.github.io/goit-markup-hw-08/",
    technologies: ["HTML", "SCSS", "Java Script"],
  },
  {
    id: 5,
    title: "Ice Cream",
    description:
      "A landing page with semantic and adaptive layout. [Command project]",
    src: "images/project-ice-cream.jpeg",
    gitHubLink: "https://github.com/still-me/team_4-project",
    livePage: "https://goodluckmister.github.io/team_4-project/",
    technologies: ["HTML", "SCSS", "Java Script"],
  },
  {
    id: 6,
    title: "Movies",
    description: "SPA for searching movies",
    src: "images/project-movies.jpeg",
    gitHubLink: "https://github.com/still-me/goit-react-hw-04-movies",
    livePage: "https://still-me-thebestmovies.netlify.app/",
    technologies: ["React", "Ract-router", "REST API"],
  },
  {
    id: 7,
    title: "Image-search",
    description: "SPA for searching images",
    src: "images/project-images.jpeg",
    gitHubLink: "https://github.com/still-me/goit-react-hw-03-image-finder",
    livePage: "https://still-me.github.io/goit-react-hw-03-image-finder/",
    technologies: ["React", "Axios", "SCSS", "REST API"],
  },
];

export default projects;
